<template>
	<router-view />



</template>

<script> 
	export default {
		data() {
			return {}
		},

		created() {				
			// this.$quanju('$yonghu',this.$qu('yonghu'))
			
			// this.$swoole();
			 
		},

	}
</script>

<style lang="scss">
	html,
	body {
		padding: 0;
		margin: 0;
	}
	@import "./plugins/icon.css";
	@import "./plugins/gudewe.css";
	@import "./plugins/wodenew.css";
	@import "./styles/reset.css";
	@import "./styles/index.scss";
	// @import "./plugins/zhiwi.css";
	.el-tabs__nav {
		margin-left: 0;
	}
	// .el-input__inner{border:0 !important; height: 100%;}
	.el-form-item__content{
		height: 100%;
		margin-left: auto;
	}
	.z-E60012 {
		color: #E60012;
	}
	.Loginanniu{
		padding: .09rem .46rem  !important;
		background:linear-gradient(87deg, #ff785c 0%, #e70a16 100%) !important;
		font-size:.18rem  !important;
		border:none!important;
	}
	.Loginanniu:hover{
		background:linear-gradient(87deg, #ff785c 0%, #e70a16 100%)!important;
		border:none!important;
	}
	.el-pager li{min-width: 30px !important;;margin: 0 .07rem !important;background: transparent !important;}
	.el-pager li:hover,.btn-prev:hover,.btn-next:hover {color: #e60012 !important;}
	.el-pager li.active {
	    color: #ffffff !important;
	    cursor: default !important;
	    background: #e60012 !important;
	}
	.el-select-dropdown__item.selected{
		// background:#faf5f5 !important;
		color: #ff4040 !important;
	}
	.btn-prev,
	.btn-next {
		background: transparent !important;
	}
	.el-table--border th.gutter:last-of-type {
	    display: block!important;
	    width: 17px!important;
	}
	.fanye{
		.el-button:focus{
			color: #333 !important;
			border:1px solid #DCDFE6;
		}
	}
	.sanjiao {height: 1rem;background:linear-gradient(to bottom right, transparent 50%, #fff 50%,#fff 100%);}
	.sanjiao3 {height: 1rem;background:linear-gradient(to bottom right, transparent 49%, #000 50%, #000 100%);}
	
	.m-auto {margin: 0 auto;}
	.cascass {
		border-radius: 20px !important;
		box-shadow: 0px 0px 76px 0px rgba(3,0,0,0.06) !important;; 
		border: none !important;;
		padding: .06rem !important;
		.is-active {
			color: #E71218 !important;
		}
		.el-checkbox,.el-checkbox__input {line-height: 0;}
		.el-checkbox__input.is-checked .el-checkbox__inner,
		.el-checkbox__input.is-indeterminate .el-checkbox__inner {
			background: #E71218 !important;
			border-color: #E71218 !important;
		}
		.el-checkbox__inner:hover {
			border-color: #E71218 !important;
		}
		.el-radio__input.is-checked .el-radio__inner{
			background: #E71218 !important;
			border-color: #E71218 !important;
		}
		.el-radio__inner:hover {
			border-color: #E71218 !important;
		}
	}
	.el-breadcrumb__inner a:hover, .el-breadcrumb__inner.is-link:hover{
		color: #E71218;
	}
	.casca {
		&,.el-cascader {
			width: 2.12rem;
			height: .5rem;
			max-height: 50px;
			min-height: 35px;
			min-width: 150px;
			line-height: inherit;
		}
		.el-input__inner:focus,
		.el-input.is-focus .el-input__inner {
			border-color: #E71218 !important;
		}
		.el-cascader {
			border-radius: 50px;
			background: #F6F6F8;
		
			.el-cascader__tags {
				left: .32rem;
				right: 0;
				width: 70%;
			}
			.el-input {display: block; height: 100%;}
			.el-input__inner {
				padding-left: .5rem;
				background: transparent;
				border-radius: 50px;
				height: 100% !important;
			}
		
			.el-input__icon {
				line-height: .5rem;
				color: #6b6b6b;
			}
		
			.el-cascader__tags :first-child.el-tag {
				width: 50%;
				flex: 1;
			}
		}
	}
.ProfileFrom-a2s1{
	line-height:50px;
}
.ProfileFrom-a4s3{
	width:96%;
	.el-input__inner{
		border:none;
		background-color: #f6f7f8 ;
		height:50px !important;
		line-height: initial ;
	}
}
	// 分页器换行
	.el-pagination {flex-wrap: wrap;}
	.el-pagination .el-pagination__jump {margin-left: 10px; min-width: 25px;}

	// 组件插件改变主题色
	.el-input.is-active .el-input__inner {border-color: #E71218;}
	.el-input__inner:focus {border-color: #E71218;}
	.el-date-table td.current:not(.disabled) span {background-color: #E71218; color: #fff;}
	.el-date-table td.today span {background-color: #E71218; color: #fff;}
	.el-date-table td.available:hover {color: #e60012;}
	.el-date-picker__header-label.active {color: #e70a16;}
	.el-date-picker__header-label:hover {color: #e70a16;}
	.el-year-table td .cell:hover {color: #e70a16;}
	.el-year-table td.current:not(.disabled) .cell {color: #e70a16;}
	.el-year-table td.today .cell {color: #e70a16;}
	.el-month-table td .cell:hover {color: #e70a16;}
	.el-month-table td.current:not(.disabled) .cell {color: #e70a16;}
	.el-button.is-plain:focus{border-color: #e70a16;color: #e70a16;}
	.el-button.is-plain:hover {border-color: #e70a16;color: #e70a16;}
	.el-time-panel__btn.confirm {color: #e70a16;}
</style>
